import React from 'react';
import { useSelector } from 'react-redux';
import UnitConvert from 'UnitConverter';

function FoodRowSimple({ food }) {
    const globals = useSelector(state => state.globals);
    const itemData = globals.itemData[food.food_id];

    const foodItem = {
        id: food.food_id,
        selectedWeight: food.amount,
        weight: itemData.weight,
        norm_unit_amount: itemData.norm_unit_amount * 1.0,
        norm_unit_unit: itemData.norm_unit_unit,
        norm_unit2_amount: itemData.norm_unit2_amount * 1.0,
        norm_unit2_unit: itemData.norm_unit2_unit,
    };

    const uc = UnitConvert;
    let normalizedUnitInfo = uc.convert(foodItem);
    if(normalizedUnitInfo && normalizedUnitInfo != ' null') {
        normalizedUnitInfo = <span>({normalizedUnitInfo})</span>;
    } else {
        normalizedUnitInfo = null;
    }

    const mods = food.modifications.map(m => globals.preparation_types[m]).filter(Boolean);

    return (
        <div className="flex relative items-center mb-[0.5em] last:mb-0 shadow-[inset_0_8px_16px_rgba(0,0,0,0.025)] bg-white" key={food.id}>
            <div className="shrink-0 grow-0 basis-[80px] mr-[0.25em]">
                <img className="h-[85px] w-auto block relative bg-white rounded-[3px] p-[10px] transition-all duration-[150ms]" src={`https://www.zofapp.cz/data/zof/item/${food.food_id}.svg`} alt="" />
            </div>
            <div className="shrink grow basis-[15em] py-[0.5em] pr-[1em] pl-[0.25em]">
                <h4 className="text-[1.15em] mb-[0.1em] mt-0 font-semibold text-[#26AA52]">{food.title}</h4>
                <p className="m-0 text-[0.85em]"><b>{parseFloat(food.amount)} {food.unit}</b> {normalizedUnitInfo}</p>
                {mods.length > 0 && <p className="m-0 text-[0.85em] mt-[0.5em] text-[#333]">{mods.join(', ')}</p>}
            </div>
        </div>
    );
}

export default FoodRowSimple;
